import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import firebase from '@/config/db.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import './assets/styles/main.min.css';

Vue.use(Loading);
Vue.component('loading', Loading);

Vue.config.productionTip = false;

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
});

function initialize() {
    new Vue({
				data: {
						isLoading: false
				},
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
}

store.dispatch('init').then(() => {
  initialize();
});
